// TODO : `React.lazy` could optimize imports throughout the project
// TODO : react optimization: [https://reactjs.org/docs/optimizing-performance.html]()
// TODO : loading skeletons: [https://www.npmjs.com/package/react-loading-skeleton]()
// TODO : load no card if any list of a list view is empty (avoids random lines)
// TODO : Interesting improvement: https://reactjs.org/docs/concurrent-mode-suspense.html
// TODO : Best would be creating a GraphQL api and use that for data fetching.

// TODO : a nice future improvement would be to disconnect after some inactive time.
// that way if the user keeps a tab open not all the updates are streamed which saves
// huge on firestore read/write costs

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    Route,
    RouterProvider,
} from "react-router";

import AdminRoute from "../components/AdminRoute/index.jsx";
import ProtectedRoute from "../components/ProtectedRoute";
import AdminAppListPage from "../pages/AdminAppListPage/index.jsx";
import AdminMissionListPage from "../pages/AdminMissionListPage";
import AdminResultListPage from "../pages/AdminResultListPage/index.jsx";
import AdminRoutineListPage from "../pages/AdminRoutineListPage";
import AppCreatePage from "../pages/AppCreatePage";
import AdminAppErrorListPage from "../pages/AppErrorListPage";
import AppSettingsPage from "../pages/AppSettingsPage";
import AreaBuilderPage from "../pages/AreaBuilderPage/index.jsx";
import ChangelogPage from "../pages/ChangelogPage/index.jsx";
import DemoPage from "../pages/DemoPage";
import DockListPage from "../pages/DockListPage";
import DockPage from "../pages/DockPage";
import DockSettingsPage from "../pages/DockSettingsPage";
import DroneCreatePage from "../pages/DroneCreatePage";
import DroneListPage from "../pages/DroneListPage";
import DroneNerdPage from "../pages/DroneNerdPage";
import DronePage from "../pages/DronePage";
import DroneSettingsPage from "../pages/DroneSettingsPage";
import ErrorPage from "../pages/ErrorPage";
import FeedbackPage from "../pages/FeedbackPage";
import FlightListPage from "../pages/FlightListPage";
import FlightPage from "../pages/FlightPage";
import ImageListPage from "../pages/ImageListPage";
import ImagePage from "../pages/ImagePage";
import LivestreamPage from "../pages/LivestreamPage/index.jsx";
import LocationAppListPage from "../pages/LocationAppListPage";
import LocationAppSettingsPage from "../pages/LocationAppSettingsPage";
import LocationCreatePage from "../pages/LocationCreatePage";
import LocationListPage from "../pages/LocationListPage";
import LocationPage from "../pages/LocationPage";
import LocationSettingsPage from "../pages/LocationSettingsPage";
import LoginPage from "../pages/LoginPage";
import MapPage from "../pages/MapPage";
import MissionListPage from "../pages/MissionListPage";
import MissionPage from "../pages/MissionPage";
import NotFoundPage from "../pages/NotFoundPage";
import OrganizationCreatePage from "../pages/OrganizationCreatePage";
import OrganizationListPage from "../pages/OrganizationListPage";
import OrganizationSettingsPage from "../pages/OrganizationSettingsPage";
import PayloadListPage from "../pages/PayloadListPage";
import PayloadSettingsPage from "../pages/PayloadSettingsPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import ResultListPage from "../pages/ResultListPage/index.jsx";
import ResultPage from "../pages/ResultPage/index.jsx";
import RoutineListPage from "../pages/RoutineListPage";
import RoutinePage from "../pages/RoutinePage";
import RoutineSettingsPage from "../pages/RoutineSettingsPage";
import StartPage from "../pages/StartPage";
import TaskAppSettingsPage from "../pages/TaskAppSettingsPage/index.jsx";
import TaskEditPage from "../pages/TaskEditPage";
import TaskListPage from "../pages/TaskListPage";
import TaskPage from "../pages/TaskPage";
import UserCreatePage from "../pages/UserCreatePage/index.jsx";
import UserManagementPage from "../pages/UserManagementPage/index.jsx";
import UserSettingsPage from "../pages/UserSettingsPage/index.jsx";
import VarietiesPage from "../pages/VarietiesPage/index.jsx";
import urls from "../urls.jsx";

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route errorElement={<ErrorPage />}>
            <Route path={urls.login()} element={<LoginPage />} />
            <Route
                path={urls.resetPassword()}
                element={<ResetPasswordPage />}
            />
            <Route
                path={urls.legacyResetPassword()}
                element={<Navigate to={urls.resetPassword()} replace />}
            />
            <Route
                path={urls.firebasePasswordResetAction()}
                element={<ResetPasswordPage />}
            />

            {/* The following routes are only for authenticated users */}
            <Route element={<ProtectedRoute />}>
                {/* User pages */}
                <Route path={urls.home()} element={<LocationListPage />} />
                <Route path={urls.feedback()} element={<FeedbackPage />} />

                <Route
                    path={urls.locationMap(":organizationId", ":locationId")}
                    element={<MapPage />}
                />

                {/* Drone pages */}
                <Route
                    path={urls.locationDroneSettings(
                        ":organizationId",
                        ":locationId",
                        ":droneId",
                    )}
                    element={<DroneSettingsPage />}
                />
                <Route
                    path={urls.locationDrone(
                        ":organizationId",
                        ":locationId",
                        ":droneId",
                    )}
                    element={<DronePage />}
                />
                <Route path={urls.drone(":droneId")} element={<DronePage />} />
                <Route
                    path={urls.droneSettings(":droneId")}
                    element={<DroneSettingsPage />}
                />
                <Route
                    path={urls.locationDrones(":organizationId", ":locationId")}
                    element={<DroneListPage />}
                />
                <Route
                    path={urls.locationDroneLivestream(
                        ":organizationId",
                        ":locationId",
                        ":droneId",
                    )}
                    element={<LivestreamPage />}
                />

                {/* Mission pages */}
                <Route
                    path={urls.locationMissions(
                        ":organizationId",
                        ":locationId",
                    )}
                    element={<MissionListPage />}
                />
                <Route
                    path={urls.mission(":missionId")}
                    element={<MissionPage />}
                />
                <Route
                    path={urls.locationMission(
                        ":organizationId",
                        ":locationId",
                        ":missionId",
                    )}
                    element={<MissionPage />}
                />
                <Route
                    path={urls.measurements(":organizationId", ":locationId")}
                    element={<ImageListPage />}
                />
                <Route
                    path={urls.locationResults(
                        ":organizationId",
                        ":locationId",
                    )}
                    element={<ResultListPage />}
                />
                <Route
                    path={urls.result(
                        ":organizationId",
                        ":locationId",
                        ":missionId",
                        ":resultId",
                        ":filename",
                    )}
                    element={<ResultPage />}
                />
                {/* TODO : decouple ImagePage from missionId, this should be a param so we can also set flightId instead */}
                <Route
                    path={urls.measurement(
                        ":organizationId",
                        ":locationId",
                        ":missionId",
                        ":measurementId",
                    )}
                    element={<ImagePage />}
                />
                <Route
                    path={urls.aMeasurement(":measurementId")}
                    element={<ImagePage />}
                />

                {/* Flight pages */}
                <Route
                    path={urls.flight(
                        ":organizationId",
                        ":locationId",
                        ":flightId",
                    )}
                    element={<FlightPage />}
                />
                <Route
                    path={urls.flights(":organizationId", ":locationId")}
                    element={<FlightListPage />}
                />

                <Route
                    path={urls.aFlight(":flightId")}
                    element={<FlightPage />}
                />

                {/* Dock pages */}
                <Route
                    path={urls.docks(":organizationId", ":locationId")}
                    element={<DockListPage />}
                />
                <Route
                    path={urls.dockCreate(":organizationId", ":locationId")}
                    element={<DockSettingsPage />}
                />
                <Route
                    path={urls.dock(
                        ":organizationId",
                        ":locationId",
                        ":dockId",
                    )}
                    element={<DockPage />}
                />
                <Route
                    path={urls.dockSettings(
                        ":organizationId",
                        ":locationId",
                        ":dockId",
                    )}
                    element={<DockSettingsPage />}
                />

                {/* Task pages */}
                <Route
                    path={urls.tasks(":organizationId", ":locationId")}
                    element={<TaskListPage />}
                />
                <Route
                    path={urls.taskCreate(":organizationId", ":locationId")}
                    element={<TaskEditPage />}
                />
                <Route
                    path={urls.task(
                        ":organizationId",
                        ":locationId",
                        ":taskId",
                    )}
                    element={<TaskPage />}
                />
                <Route path={urls.aTask(":taskId")} element={<TaskPage />} />
                <Route
                    path={urls.taskSettings(
                        ":organizationId",
                        ":locationId",
                        ":taskId",
                    )}
                    element={<TaskEditPage />}
                />
                <Route
                    path={urls.taskAppSettings(
                        ":organizationId",
                        ":locationId",
                        ":taskId",
                        ":appId",
                    )}
                    element={<TaskAppSettingsPage />}
                />

                {/* Routine pages */}
                <Route
                    path={urls.routines(":organizationId", ":locationId")}
                    element={<RoutineListPage />}
                />
                <Route
                    path={urls.routineCreate(":organizationId", ":locationId")}
                    element={<RoutineSettingsPage />}
                />
                <Route
                    path={urls.routineSettings(
                        ":organizationId",
                        ":locationId",
                        ":routineId",
                    )}
                    element={<RoutineSettingsPage />}
                />
                <Route
                    path={urls.routine(
                        ":organizationId",
                        ":locationId",
                        ":routineId",
                    )}
                    element={<RoutinePage />}
                />

                <Route
                    path={urls.locationStart(":organizationId", ":locationId")}
                    element={<StartPage />}
                />
                <Route
                    path={urls.location(":organizationId", ":locationId")}
                    element={<LocationPage />}
                />
                <Route
                    path={urls.locationSettings(
                        ":organizationId",
                        ":locationId",
                    )}
                    element={<LocationSettingsPage />}
                />
                <Route
                    path={urls.locationCreate(":organizationId")}
                    element={<LocationCreatePage />}
                />
                <Route
                    path={urls.organization(":organizationId")}
                    element={<LocationListPage />}
                />
                <Route
                    path={urls.organizationSettingsPage(":organizationId")}
                    element={<OrganizationSettingsPage />}
                />
                <Route
                    path={urls.locations(":organizationId")}
                    element={<LocationListPage />}
                />

                <Route element={<AdminRoute />}>
                    <Route
                        path={urls.organizations()}
                        element={<OrganizationListPage />}
                    />

                    <Route path={urls.demo()} element={<DemoPage />} />

                    <Route
                        path={urls.users()}
                        element={<UserManagementPage />}
                    />
                    <Route
                        path={urls.userCreate()}
                        element={<UserCreatePage />}
                    />
                    <Route
                        path={urls.userSettings(":uid")}
                        element={<UserSettingsPage />}
                    />

                    <Route
                        path={urls.locationApps(
                            ":organizationId",
                            ":locationId",
                        )}
                        element={<LocationAppListPage />}
                    />
                    <Route
                        path={urls.locationAppSettings(
                            ":organizationId",
                            ":locationId",
                            ":appId",
                        )}
                        element={<LocationAppSettingsPage />}
                    />
                    <Route
                        path={urls.varieties(":organizationId", ":locationId")}
                        element={<VarietiesPage />}
                    />
                    <Route
                        path={urls.areaBuilder(
                            ":organizationId",
                            ":locationId",
                        )}
                        element={<AreaBuilderPage />}
                    />
                    <Route
                        path={urls.allApps()}
                        element={<AdminAppListPage />}
                    />
                    <Route
                        path={urls.appSettings(":appId")}
                        element={<AppSettingsPage />}
                    />
                    <Route
                        path={urls.appCreate(":appId")}
                        element={<AppCreatePage />}
                    />

                    <Route
                        path={urls.allMissions()}
                        element={<AdminMissionListPage />}
                    />
                    <Route
                        path={urls.allResults()}
                        element={<AdminResultListPage />}
                    />
                    <Route
                        path={urls.allAppErrors()}
                        element={<AdminAppErrorListPage />}
                    />

                    <Route
                        path={urls.allRoutines()}
                        element={<AdminRoutineListPage />}
                    />

                    <Route
                        path={urls.organizationCreate()}
                        element={<OrganizationCreatePage />}
                    />

                    <Route
                        path={urls.changelogs()}
                        element={<ChangelogPage />}
                    />
                    <Route
                        path={urls.payloadSettings(":payloadId")}
                        element={<PayloadSettingsPage />}
                    />
                    <Route
                        path={urls.payloads()}
                        element={<PayloadListPage />}
                    />

                    <Route
                        path={urls.droneCreate(
                            ":organizationId",
                            ":locationId",
                        )}
                        element={<DroneCreatePage />}
                    />
                    <Route
                        path={urls.locationDroneNerd(
                            ":organizationId",
                            ":locationId",
                            ":droneId",
                        )}
                        element={<DroneNerdPage />}
                    />
                </Route>

                {/* Other pages */}
                <Route element={<NotFoundPage />} />
            </Route>
        </Route>,
    ),
    {
        future: {
            v7_relativeSplatPath: true,
            v7_startTransition: true,
        },
    },
);

export default function App() {
    return <RouterProvider router={router} />;
}
